import { AddCircleRounded, MenuRounded } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import TaskTabs from "./Tabs";
import { useEffect, useMemo, useState } from "react";
import { TaskStatus } from "./constants";
import TaskList from "./TaskList";
import Button from "@mui/material/Button";
import classNames from "classnames";
import TaskModal from "./TaskModal";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchTasks, setShowTaskModal } from "../../redux/slices/taskSlice";
import { useOutletContext } from "react-router-dom";
import { MainLayoutType } from "../../assets/interfaces/interfaces";
import useMediaQuery from "@mui/material/useMediaQuery";
import { theme } from "../../theme";
import { createSelector } from "@reduxjs/toolkit";

const tabs = [{ id: 1, label: "Active" }, { id: 2, label: "Inactive" }, { id: 3, label: "All Tasks" }];

export const selectActiveTaskCount = createSelector(
  (state: RootState) => state.tasks.tasks,
  tasks => tasks.filter(task => task.status === TaskStatus.ENABLED).length,
);
const TaskDashboard = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  const dispatch = useDispatch<AppDispatch>();

  const { tasks: allTasks } = useSelector((state: RootState) => state.tasks);

  useEffect(() => {
    const getAllTasks = async () => {
      try {
        await dispatch(fetchTasks());
      }
      catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };
    getAllTasks();
  }, []);

  const countOfActiveTasks = useMemo(
    () => allTasks.filter(task => task.status === TaskStatus.ENABLED).length,
    [allTasks],
  );
  const filteredTasks = useMemo(() => {
    switch (selectedTab) {
      case 1:
        return allTasks.filter(task => task.status === TaskStatus.ENABLED);
      case 2:
        return allTasks.filter(task => task.status === TaskStatus.DISABLED);
      default:
        return allTasks;
    }
  }, [selectedTab, allTasks]);

  const { width, setIsSidebarExpanded } = useOutletContext<MainLayoutType>();
  const isSmallScreen = width < 768;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div className="p-8">
      <div className="flex justify-between">
        <div className="flex items-center gap-x-2 pb-2">
          {isMobile && <IconButton onClick={() => setIsSidebarExpanded(true)}><MenuRounded className="fill-action-active"></MenuRounded></IconButton>}
          <Typography variant="h5/regular-400" className="text-mui-black-87 dark:text-white">Scheduled Tasks</Typography>
        </div>
        {!isSmallScreen && (
          <Button
            variant="contained"
            size="medium"
            className={classNames(
              "!text-transform-none flex gap-x-2",
              "dark:!text-white",
              "!bg-tgpt-secondary-main",
              "disabled:dark:!text-mui-white-38",
              "disabled:!bg-action-disabled-background",
            )}
            onClick={() => dispatch(setShowTaskModal(true))}
          >
            <AddCircleRounded></AddCircleRounded>
            New task
          </Button>
        )}
        {isSmallScreen && (
          <IconButton onClick={() => dispatch(setShowTaskModal(true))}>
            <AddCircleRounded className="!fill-tgpt-secondary-main"></AddCircleRounded>
          </IconButton>
        )}
      </div>
      <TaskTabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <section className="pt-6">
        <TaskList tasks={filteredTasks} isSmallScreen={isSmallScreen} />
      </section>
      <TaskModal countOfActiveTasks={countOfActiveTasks} />
    </div>
  );
};

export default TaskDashboard;
